/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ShieldFilledIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="shield-filled"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M12 2.5C12.121 2.646 12.239 2.795 12.364 2.936C12.742 3.361 13.159 3.751 13.609 4.099C14.96 5.146 16.597 5.803 18.297 5.981C18.674 6.02 19.053 6.036 19.432 6.029C19.622 6.025 19.811 6.01 20 6C20.221 6.635 20.293 6.79 20.451 7.445C20.689 8.427 20.799 9.44 20.777 10.45C20.749 11.713 20.514 12.97 20.085 14.158C19.656 15.346 19.033 16.463 18.248 17.452C17.462 18.441 16.515 19.3 15.455 19.987C14.819 20.399 14.143 20.749 13.44 21.03C12.814 21.281 12.646 21.312 12 21.5C11.354 21.312 11.186 21.281 10.56 21.03C9.622 20.656 8.733 20.158 7.923 19.555C6.909 18.801 6.021 17.882 5.301 16.844C4.581 15.806 4.032 14.651 3.681 13.438C3.329 12.224 3.177 10.955 3.231 9.693C3.264 8.936 3.37 8.182 3.549 7.445C3.707 6.79 3.779 6.635 4 6C4.189 6.01 4.378 6.025 4.568 6.029C4.947 6.036 5.326 6.02 5.703 5.981C7.403 5.803 9.04 5.146 10.391 4.099C10.841 3.751 11.258 3.361 11.636 2.936C11.761 2.795 11.878 2.646 12 2.5Z" data-tinysvg-shape="path" stroke="none" fill={color} data-fill-tone="primary" />
          <path d="M12 2.5A9.217 9.217 0 0 1 4 6" data-tinysvg-shape="arc" data-tinysvg-arc="4.747 -3.186 9.217 9.217 38.096 94.646 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M12 21.5A11.67 11.67 0 0 1 4 6" data-tinysvg-shape="arc" data-tinysvg-arc="14.891 10.193 11.67 11.67 104.343 201.058 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20 6A11.67 11.67 0 0 1 12 21.5" data-tinysvg-shape="arc" data-tinysvg-arc="9.109 10.193 11.67 11.67 338.942 435.657 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M20 6A9.217 9.217 0 0 1 12 2.5" data-tinysvg-shape="arc" data-tinysvg-arc="19.253 -3.186 9.217 9.217 85.354 141.904 0 three-point" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
